module.exports = __webpack_public_path__ + "packs/media/images/Match_Active-2ce6cb8abc85453b3f078ef7ce653f5e.svg";